import userTodoMapper from "@/mappers/userTodoMapper";
import { useUserTodos } from "@cs_teamwaydev/mailvista-sdk_react";
import { useMemo } from "react";
import useLiveErrorNotifier from "./utils/useLiveErrorNotifier";

// Todos for the Smart Todos dashboard widget, done ones included.
// Mobile equivalent: ToDoScreen.tsx.
const useGetDashboardTodos = () => {
    const { data, isLoading, error } = useUserTodos();
    useLiveErrorNotifier(error, { titleTranslationKey: "errors.getTodos" });

    const todos = useMemo(() => data?.map(userTodoMapper), [data]);

    return { data: todos, isLoading, error };
};

export default useGetDashboardTodos;
